'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var URI = _interopDefault(require('urijs'));

var getAuthDomain = function getAuthDomain() {
	var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.origin;

	var domainUrl = URI(url);
	var domain = domainUrl.host().match(/([^.]+)\.(com|net|org|info|io|co\.uk)/i);
	return '.' + domain[0];
};

exports.getAuthDomain = getAuthDomain;
